/**
 * Resource phiếu nhập kho
 * hkcuong 19.01.2026
 */
export default {
  Title: "Nhập khẩu phiếu nhập kho",
  ImportedInwardStockResult: 'Danh sách phiếu nhập kho nhập khẩu thành công',
  
  // Import messages
  DownloadResult: 'Tải kết quả',
  CannotContinueImport: 'Không thể tiếp tục nhập khẩu',
  
  // Tab titles
  ImportedInwardResult: 'Danh sách phiếu nhập kho nhập khẩu thành công',
  ImportedDecisionResult: 'Danh sách quyết định  nhập khẩu thành công ',
  ImportedObjectResult: 'Danh sách đối tượng nhập khẩu thành công',
  ImportedAssetResult: 'Danh sách tài sản nhập khẩu thành công',
  
  // ImportedInwardList columns (Tab Chứng từ)
  ImportedInwardList: {
    AreaCode: 'Khu vực',
    RefType: 'Loại CT',
    RefNo: 'Số CT',
    RefDate: 'Ngày CT',
    Description: 'Diễn giải',
    TotalAmount: 'Số tiền',
    VoucherListId: 'Chứng từ nghiệp vụ khác tham chiếu'
  },
  
  // ImportedAssetList columns (Tab Tài sản)
  ImportedAssetList: {
    AssetCode: 'Mã tài sản',
    AssetName: 'Tên tài sản',
    Category: 'Loại tài sản',
    Area: 'Khu vực',
    Quantity: 'Số lượng',
    OriginalPrice: 'Nguyên giá',
    Specification: 'Mô tả',
    UnitPrice: 'Đơn giá'
  }
};
